import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function GDRTeam() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with RIDE RED */}
      <div className="relative h-[60vh] md:h-screen mt-16 md:mt-24">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(a9.webp)',
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-5xl md:text-9xl font-black text-red-600 uppercase tracking-wider text-center leading-tight">
              Ride<br />Red
            </h1>
          </div>
        </div>
      </div>

      {/* Team Title Section */}
      <section className="py-6 md:py-8 bg-white">
        <div className="max-w-[1300px] mx-auto px-4 md:px-6">

          {/* Championship Badges */}
          <div className="flex justify-center mb-8 md:mb-16">
            <img src="/champ.webp" alt="Championship Badges" className="w-auto max-w-full" />
          </div>
        </div>
      </section>

      {/* Team Stats Section */}
      <section className="py-0 mb-8 bg-white">
        <div className="max-w-[1200px] mx-auto">
          <div className="relative h-[400px] md:h-[600px]">
            <img 
              src="a7.jpeg" 
              alt="Team Stats" 
              className="w-full h-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-4xl md:text-8xl font-bold mb-6 md:mb-12">
                  <span className="text-white">Team </span>
                  <span className="text-red-600">Stats.</span>
                </h2>
                <div className="space-y-3 md:space-y-6 text-black text-xl md:text-4xl font-semibold">
                  <p>Moto wins: 115</p>
                  <p>Podiums: 141</p>
                  <p>Overall Wins: 67</p>
                  <p>Championships: 9</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Riders Section */}
      <section className="py-12 md:py-16 bg-black text-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          {/* Dylan Wright */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-6 md:gap-12 mb-12 md:mb-20">
            <div>
              <img 
                src="a11.jpeg" 
                alt="Dylan Wright" 
                className="w-full h-auto grayscale"
              />
            </div>
            <div>
              <h3 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8">
                Dylan <span className="text-red-600">Wright.</span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 md:gap-x-12 gap-y-3 md:gap-y-4 text-base md:text-lg">
                <div>
                  <p className="mb-3"><span className="font-semibold">Class:</span> 450 Motocross</p>
                  <p className="mb-3"><span className="font-semibold">9th year at GDR</span></p>
                  <p className="mb-3"><span className="font-semibold">Age:</span> 27</p>
                  <p className="mb-3"><span className="font-semibold">Residence:</span> Drummondville, QC</p>
                </div>
                <div>
                  <p className="mb-3"><span className="font-semibold">Moto wins:</span> 84</p>
                  <p className="mb-3"><span className="font-semibold">Podiums:</span> 70</p>
                  <p className="mb-3"><span className="font-semibold">Overall Wins:</span> 41</p>
                  <p className="mb-3"><span className="font-semibold">Championships:</span> 5</p>
                </div>
              </div>
            </div>
          </div>

          {/* Ryder McNabb */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-6 md:gap-12 mb-12 md:mb-20">
            <div>
              <img 
                src="a13.jpg" 
                alt="Ryder McNabb" 
                className="w-full h-auto grayscale"
              />
            </div>
            <div>
              <h3 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8">
                Ryder <span className="text-red-600">McNabb.</span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 md:gap-x-12 gap-y-3 md:gap-y-4 text-base md:text-lg">
                <div>
                  <p className="mb-3"><span className="font-semibold">Class:</span> 250 Motocross</p>
                  <p className="mb-3"><span className="font-semibold">4th year at GDR</span></p>
                  <p className="mb-3"><span className="font-semibold">Age:</span> 19</p>
                  <p className="mb-3"><span className="font-semibold">Residence:</span> Minnedosa, MB</p>
                </div>
                <div>
                  <p className="mb-3"><span className="font-semibold">Moto wins:</span> 14</p>
                  <p className="mb-3"><span className="font-semibold">Podiums:</span> 21</p>
                  <p className="mb-3"><span className="font-semibold">Overall Wins:</span> 10</p>
                  <p className="mb-3"><span className="font-semibold">Championships:</span> 2</p>
                </div>
              </div>
            </div>
          </div>

          {/* Noah Viney */}
          <div className="grid grid-cols-1 md:grid-cols-[300px_1fr] gap-6 md:gap-12">
            <div>
              <img 
                src="a8.jpg" 
                alt="Noah Viney" 
                className="w-full h-auto grayscale"
              />
            </div>
            <div>
              <h3 className="text-3xl md:text-5xl font-bold mb-6 md:mb-8">
                Noah <span className="text-red-600">Viney.</span>
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 md:gap-x-12 gap-y-3 md:gap-y-4 text-base md:text-lg">
                <div>
                  <p className="mb-3"><span className="font-semibold">Class:</span> 250 Motocross</p>
                  <p className="mb-3"><span className="font-semibold">2nd year at GDR</span></p>
                  <p className="mb-3"><span className="font-semibold">Age:</span> 19</p>
                  <p className="mb-3"><span className="font-semibold">Residence:</span> Ottawa, ON</p>
                </div>
                <div>
                  <p className="mb-3"><span className="font-semibold">Moto wins:</span> 0</p>
                  <p className="mb-3"><span className="font-semibold">Podiums:</span> 0</p>
                  <p className="mb-3"><span className="font-semibold">Overall Wins:</span> 0</p>
                  <p className="mb-3"><span className="font-semibold">Championships:</span> 0</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Honda Bikes Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6">
          
          
          <div className="flex justify-center">
            <img 
              src="/bike.webp" 
              alt="Honda 2025 Bikes" 
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      {/* Honda Contest Section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          <img 
            src="/honda.webp" 
            alt="Honda 2025 $10K Your Way Contest" 
            className="w-full h-auto"
          />
        </div>
      </section>

      {/* Team Personnel Section */}
      <section className="py-16 bg-white">
        <div className="max-w-[1200px] mx-auto px-6">
          

          <div className="flex justify-center">
            <img 
              src="/sec.webp" 
              alt="Team Personnel" 
              className="w-full h-auto"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default GDRTeam;
